import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker"
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import MatButton from '@mui/material/Button';
import Selectsearch from "react-select";
import {
    FormGroup,
    Label,

} from 'reactstrap';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
// import UploadDialog from './UploadDocument';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Checkbox from '@mui/material/Checkbox'

import { withStyles } from '@mui/styles';
// import Checkbox from '@mui/material/Checkbox';

import UpdateStudents1 from './editenrolment';
import AddAgreement from './addagreement';
import ViewDocument from './viewdocument';
import ViewAgreement from './agreement/viewagreement';

import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    contractProgramInclusion,
    contractFetchStudent,
    contractUpdateNotes,
    deleteStudentProgramInclusion,
    contractUploadDocument,
    contractAddPginc,
    deleteStudentAgreement,
    cancelStudentAgreement,
    deleteStudentDocument,
    fetchStudentDocument,
    fetchStudentAgreement,
    agreementAllDetails,
    editStudentAgreement,
} from 'Actions';


const LargeCheckbox = withStyles({
    root: {
        width: '3em',
        height: '3em',
        padding: 0,
        '& .MuiSvgIcon-root': {
            fontSize: '2em',
        },
    },
})(Checkbox);

class UpdateStudent extends React.Component {

    static propTypes = {
        classes: PropTypes.object,
        prev: PropTypes.number,
    };

    static num1 = 0;

    constructor(props) {
        super(props);
        this.confirmationDialog = React.createRef();
        this.confirmationDocument = React.createRef();
        this.confirmationAgreement = React.createRef();
        this.addNotes = this.addNotes.bind(this);
        this.state = {
            addagre:false,
            showDialog: false,
            showModal: false,
            viewdiv: true,
            adddiv: false,
            editdiv: false,
            viewdoc:false,
            ediv: false,
            vdiv: false,
            name: this.props.data.uud_firstName,
            email: this.props.data.uud_email,
            ctsID: this.props.data.ctsd_notes,
            foodPreference: '',
            foodAllergies: '',
            mobile: '',
            file: null,
            description: '',
            notes: this.props.data.ctsd_notes || '',
            showDocumentModal: false,
            editAgreementModal:false,
            description: '',
            selectedFile: null,
            base64Image: '',
            fetchid:this.props.data.fetchid,
            vfm:1,
            cstid:0,
            startdate:'',
            enddate:'',
            excudate:'',
            agrtype:"",
            agrmteid:'',
            parentage:'0',
        };
        this.onAddSession = this.onAddSession.bind(this);
        this.onBackSection = this.onBackSection.bind(this);
        this.onAddSession1 = this.onAddSession1.bind(this);
        this.handleNotesChange = this.handleNotesChange.bind(this);
        this.addNotes = this.addNotes.bind(this);
        this.handleProgramInclusion = this.handleProgramInclusion.bind(this);
        this.deleteForm = this.deleteForm.bind(this);
        this.deleteDocument = this.deleteDocument.bind(this);
        this.deleteAgreement = this.deleteAgreement.bind(this);
        this.cancelAgreement = this.cancelAgreement.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.openDocumentModal = this.openDocumentModal.bind(this);
        this.handleAddPgi = this.handleAddPgi.bind(this)


    }
    
    UNSAFE_componentWillMount() {
        const parentDetails = this.props.particularcontractstudent.parent[0];
        var parentdob=parentDetails.uud_dob;
        
        var parentage=this.calculate_age(parentdob);
         this.setState({
             parentage: parentage
         });
     }

    calculate_age = (dob1) => {
        
        var today = new Date();
        var birthDate = new Date(dob1);
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
        {
            age_now--;
        }
        
        return age_now;
    }

    onAddSession() {
        this.setState({
            viewdiv: false,
            editdiv: false,
            adddiv: true,
            vdiv: false,
            ediv: false,
            viewdoc:false,
            viewagr:false,
            addagre:false,
        });
    }

    onBackSection() {
        this.setState({
            adddiv: false,
            viewdiv: true,
            editdiv: false,
            vdiv: false,
            ediv: false,
            viewdoc:false,
            viewagr:false,
            addagre:false,
        });
    }

    onAddSession1() {
        const parentDetails = this.props.particularcontractstudent.parent[0];
        const studentDetails = this.props.particularcontractstudent.student[0];
        this.setState({
            ediv: true,
            viewdiv: false,
            adddiv: false,
            vdiv: false,
            addagre:false,
            parentDetails,
            studentDetails,
        })
    }

    handleNotesChange(event) {
        const notes = event.target.value;
        this.setState({
            notes: notes
        });
    }

    addNotes() {
        const {
            particularcontractstudent: {
                student: [{ ctsd_studentID }],
            },
        } = this.props;
        const { notes } = this.state;
        const { contractUpdateNotes } = this.props;
        console.log(ctsd_studentID, "ctsd_studentID");
        console.log(this.props.particularcontractstudent.student[0]);
        contractUpdateNotes(ctsd_studentID, notes).then((data) => {
            console.log(this.props.data, "ctsd_studentID");
        });
    }

    handleFileChange = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                selectedFile: file,
                base64Image: reader.result,
            });
        };

        reader.readAsDataURL(file);
    };

    handleDescriptionChange = (event) => {
        this.setState({ description: event.target.value });
    };


    handleUpload(ctsd_studentID) {
        const { description, base64Image, fetchid } = this.state;
      
        this.props.contractUploadDocument(ctsd_studentID, description, base64Image, fetchid)
            .then((data) => {
                console.log(data)
            })
            .catch((error) => {
                console.log(error)
            });
    }

    deleteForm(data) {
        this.id = data;
        this.ctid = this.state.fetchid;
        this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse) {
        if (popupResponse) {
            this.props.deleteStudentProgramInclusion(this.id, this.ctid);
            this.data = "";
        }
    }

    deleteDocument(data) {
        this.id = data;
        this.ctid = this.state.fetchid;
        this.confirmationDocument.current.openDialog();
    }

    deleteDataDocument(popupResponse) {
        if (popupResponse) {
            this.props.deleteStudentDocument(this.id, this.ctid);
            this.data = "";
        }
    }

    deleteAgreement(data) {
        this.id = data;
        this.ctid = this.state.fetchid;
        this.confirmationAgreement.current.openDialog();
    }

    deleteDataAgreement(popupResponse) {
        if (popupResponse) {
            this.props.deleteStudentAgreement(this.id, this.ctid);
            this.data = "";
        }
    }

    cancelAgreement(id){
        var ctid = this.state.fetchid;
        if(window.confirm('Are you sure to cancel this agreement?')){         
           this.props.cancelStudentAgreement(id, ctid);    
        }
    }

    viewDocument(id) {
        
        this.props.fetchStudentDocument(id).then((data) => {   
            
            this.setState({
                viewdiv: false,
                editdiv: false,
                adddiv: false,
                vdiv: false,
                ediv: false,                
                addagre:false,
                viewdoc:true,
            });
        });        
    }

    viewAgreement(id) {
        
        this.props.fetchStudentAgreement(id).then((data) => {   
            
            this.setState({
                cstid:id,
                viewdiv: false,
                editdiv: false,
                adddiv: false,
                vdiv: false,
                ediv: false,                
                addagre:false,
                viewdoc:false,
                viewagr:true,
            });
        });        
    }

    editAgreement(rawdata){
        var eid=rawdata.ctsaID;
        var startdate=rawdata.ctsa_agreement_start_date;
        var enddate=rawdata.ctsa_agreement_end_date;
        var excudate=rawdata.ctsa_agreement_execution_date;
        var type=rawdata.ctsa_agreement_type;
       
        this.setState({
            agrmteid:eid,
            startdate: startdate,
            enddate: enddate,
            excudate: excudate,
            agrtype: type != null && type !== '' ? String(type) : '',
            editAgreementModal:true
        });
    }

    handleEdAgrmdate(e, val){
       var date=e.target.value;
       
       if(val==1){
        this.setState({
            startdate: date,
        });
       }else if(val==2){
        this.setState({
            enddate: date,
        });
       }else if(val==3){
        this.setState({
            excudate: date,
        });
       }

    }

    handleEditAgreement(){
        
        const{ agrmteid, startdate, enddate, excudate, agrtype, fetchid } = this.state;
        this.props.editStudentAgreement(agrmteid, startdate, enddate, excudate, agrtype, fetchid)
            .then((data) => { 
                this.setState({  editAgreementModal:false});
            });
           
    }


    openDocumentModal = () => {
        this.setState({ showDocumentModal: true });
    };

    handleProgramInclusion(ctsd_studentID) {
        this.props.contractProgramInclusion(ctsd_studentID)
            .then((data) => {
                const programName = data.data.program;
                const agreementID = data.data.agreementID;
                
                const showModal = true;

                this.setState({ showModal, programName, details: data, agreementID });
            })
            .catch((error) => {
                const programName = [];
                const showModal = true;

                this.setState({ showModal, programName, details: null });
            });
    }

    handleAddPgi(ctsd_studentID) {
  const { agreementID, programName } = this.state;
  const selectedProgramIds = programName
    .filter(p => p.selected)
    .map(p => p.id);
  
    const ctid = this.state.fetchid;
  const programInclusions = {
    pginclstud: ctsd_studentID,
    pginclagremt: agreementID,
    programinclusion: selectedProgramIds
  };
 

  this.props.contractAddPginc(ctsd_studentID, agreementID, selectedProgramIds, ctid)
    .then((data) => {
        this.setState({ showModal: false });
    })
    .catch((error) => {
   
    });
}

// Add Agreement .......................//
AddAgreementView() {
    this.props.agreementAllDetails().then((data) => {   
        const parentDetails = this.props.particularcontractstudent.parent[0];
        const studentDetails = this.props.particularcontractstudent.student[0];
        const program = this.props.particularcontractstudent.program
        this.setState({
            ediv: false,
            viewdiv: false,
            adddiv: false,
            vdiv: false,
            addagre:true,
            parentDetails,
            studentDetails,
        })

    });
    
}
    render() {
        const { particularcontractstudent } = this.props;

        const student = particularcontractstudent.student[0];
        const parent = particularcontractstudent.parent[0];
        const program = particularcontractstudent.program;
        const agreements = particularcontractstudent.agreements;
        const documents = particularcontractstudent.documents;
        const stdate = particularcontractstudent.laststdate;
        const eddate = particularcontractstudent.lasteddate;
        
        const { programName } = this.state;
        const agreementtype=[
            {"id":"1", "name":"Master"},
            {"id":"2", "name":"Renewal"}
        ];
        const agreementTypeOptions = agreementtype.map(finval => ({ value: String(finval.id), label: finval.name }));

        if(agreements.length==0){
            var enrollmentid='';
        }else{
            var enrollmentid=agreements[0].ctsa_enrollmentID;
        }

        const { contractUploadDocument } = this.props;

        return (
            <div>
                {this.state.viewdiv && (
                    <div className="row gx-3">
                        <div className="col-sm-12 col-lg-12">
                            <RctCollapsibleCard
                                heading={
                                    <div style={{ display: 'flex', alignItems: 'center', borderBottom: "1px solid #ccc" }}>
                                        <span>Details</span>
                                        <button type="button" className="mr-10 mb-10 btn btn-outline-warning ml-auto" onClick={this.props.onClick}>Back</button>
                                    </div>
                                }
                            >
                                <div className="d-flex justify-content-between mb-3">
                                    <div className="dfsdf"><strong>Student Profile</strong></div>
                                    <button type="button" className="mr-10 mb-10 btn btn-outline-danger" onClick={() => this.onAddSession1()}>Edit Enrolment</button>
                                </div>

                                <div className="row" style={{ borderBottom: "2px solid #ccc", paddingBottom: "20px" }}>
                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <div className="dfsdf">Name : <strong>{student.uud_firstName} {student.uud_lastName}</strong> </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <div className="dfsdf">Food Preference: <strong>{student.ctsd_food}</strong></div>
                                    </div>

                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <div className="dfsdf">Email : <strong>{student.uud_email}</strong></div>
                                    </div>

                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <div className="dfsdf">Food Allergies : <strong>{student.ctsd_foodallergies}</strong></div>
                                    </div>

                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <div className="dfsdf">Mobile : <strong>{student.uud_phone}</strong></div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <div className="dfsdf">Medical Condition : <strong>{student.ctsd_medical}</strong></div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <div className="dfsdf">Date Of Birth : <strong>{student.uud_dob}</strong></div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <div className="dfsdf">Any Other Information : <strong>{student.ctsd_otherdetails}</strong></div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <div className="dfsdf">Blood Group : <strong>{student.ctsd_bloodgroup}</strong></div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <div className="dfsdf">Enrolment ID : <strong> {enrollmentid}</strong></div>
                                    </div>
                                </div>


                                <div style={{ borderBottom: "2px solid #ccc", paddingBottom: "20px", display: "flex", flexDirection: "row", flexWrap: "wrap", paddingTop: "20px" }}>
                                    <div className="col-sm-12 col-lg-8">
                                        <div className="dfsdf"><strong>Parent Details</strong></div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6 col-xl-6" style={{ width: "50%" }}>
                                        <div className="dfsdf">Name: <strong>{parent.uud_firstName}</strong></div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6 col-xl-6" style={{ width: "50%" }}>
                                        <div className="dfsdf">Age: <strong>{this.state.parentage}</strong></div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6 col-xl-6" style={{ width: "50%" }}>
                                        <div className="dfsdf">Email: <strong>{parent.uud_email}</strong></div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6 col-xl-6" style={{ width: "50%" }}>
                                        <div className="dfsdf">Address: <strong>{parent.uud_address}</strong></div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6 col-xl-6" style={{ width: "50%" }}>
                                        <div className="dfsdf">Mobile: <strong>{parent.uud_phone}</strong></div>
                                    </div>
                                </div>


                                <div style={{ borderBottom: "2px solid #ccc", paddingBottom: "20px", paddingTop: "20px" }}>
                                    <div className="dfsdf"><strong>Program Inclusions</strong></div>
                                    <div className="row float-right">
                                        <button type="button" data-toggle="modal" data-target="#exampleModal" className="mr-10 mb-10 btn btn-outline-info float-right" onClick={() => this.handleProgramInclusion(student.ctsd_studentID)}>
                                            Add Program Inclusion
                                        </button>
                                    </div>
                                    <div className="table-responsive">
                                    <table className="table">
                                        <thead style={{ backgroundColor: "transparent" }}>
                                            <tr>
                                                <th scope="col">SNO.</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">AGREEMENT START DATE</th>
                                                <th scope="col">AGREEMENT END DATE</th>
                                                <th scope="col">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {program.map((p, index) => (
                                                <tr key={p.csdID}>
                                                    <th scope="row">{index + 1}</th>
                                                    <td>{p.name}</td>
                                                    <td>{stdate}</td>
                                                    <td>{eddate}</td>
                                                    <td style={{ color: "red", cursor: "pointer" }} onClick={() => this.deleteForm(p.ctpiID)}><CloseIcon /></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    </div>
                                </div>


                                <div style={{ borderBottom: "2px solid #ccc", paddingBottom: "20px", display: "flex", flexDirection: "row", flexWrap: "wrap", paddingTop: "20px" }}>
                                    <div className="col-sm-12 col-lg-12">
                                        <div className="dfsdf"><strong>Agreements</strong></div>
                                        <div className="row justify-content-end">
                                            <button type="button" className="mr-10 mb-10 btn btn-outline-info" onClick={() => this.AddAgreementView()}>Add Agreement</button>
                                        </div>
                                        <div className="table-responsive">
                                        <table className="table">
                                            <thead style={{ backgroundColor: "transparent" }}>
                                                <tr>
                                                    <th scope="col">SNO.</th>
                                                    <th scope="col">AGREEMENT TYPE</th>
                                                    <th scope="col">EXECUTION DATE</th>
                                                    <th scope="col">AGREEMENT START DATE</th>
                                                    <th scope="col">AGREEMENT END DATE</th>
                                                    <th scope="col">STATUS</th>
                                                    <th scope="col">ACTION</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {agreements.map((a, index) => (
                                                    <tr key={a.ctsaID}>
                                                        <td>{index + 1}</td>
                                                        <td>{a.name}</td>
                                                        <td>{new Date(a.ctsa_agreement_execution_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/(\d+)(\w{2})/, '$1$2 ')}</td>
                                                        <td>{a.stdate}</td>
                                                        <td>{a.eddate}</td>
                                                        {a.ctsa_status==2?
                                                          <td style={{color:"red"}}>Cancelled</td>
                                                        :
                                                          <td></td>
                                                        }

                                                        {a.ctsa_acceptedBy==0 ?
                                                            <td>
                                                                <button className="mr-10 mb-10 btn btn-info btn-sm" onClick={() => this.viewAgreement(a.ctsaID)}>View</button>
                                                                <button className="mr-10 mb-10 btn btn-danger btn-sm" onClick={() => this.deleteAgreement(a.ctsaID)}>Delete</button>
                                                                <button className="mr-10 mb-10 btn btn-primary btn-sm" onClick={() => this.editAgreement(a)}>Edit</button>
                                                            </td>                                                            
                                                         :
                                                            <td>
                                                                <button className="mr-10 mb-10 btn btn-info btn-sm" onClick={() => this.viewAgreement(a.ctsaID)}>View</button>
                                                                <button className="mr-10 mb-10 btn btn-danger btn-sm" onClick={() => this.cancelAgreement(a.ctsaID)}>Cancel</button>
                                                            </td>                                                            
                                                         }
                                                        
                                                        
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                </div>


                                <div style={{ borderBottom: "2px solid #ccc", paddingBottom: "20px", display: "flex", flexDirection: "row", flexWrap: "wrap", paddingTop: "20px" }}>
                                    <div className="col-sm-12 col-lg-12">
                                        <div className="dfsdf"><strong>Document Uploads</strong></div>
                                        <div className="row justify-content-end">
                                            <button type="button" className="mr-10 mb-10 btn btn-outline-info" onClick={this.openDocumentModal}>Upload Document</button>
                                        </div>
                                        <div className="table-responsive">
                                        <table className="table">
                                            <thead style={{ backgroundColor: "transparent" }}>
                                                <tr>
                                                    <th scope="col">SNO.</th>
                                                    <th scope="col">FILE NAME</th>
                                                    <th scope="col">DESCRIPTION</th>
                                                    <th scope="col">ACTION</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {documents.map((d, index) => (
                                                    <tr >
                                                        <td>{index + 1}</td>
                                                        <td>{d.csd_filename}</td>
                                                        <td>{d.csd_desc}</td>
                                                        <td>
                                                            <button className="mr-10 mb-10 btn btn-info btn-sm" onClick={() => this.viewDocument(d.csdID)}>View</button>
                                                            <button className="mr-10 mb-10 btn btn-danger btn-sm" onClick={() => this.deleteDocument(d.csdID)}>Delete</button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ paddingBottom: "20px", display: "flex", flexDirection: "row", flexWrap: "wrap", paddingTop: "20px" }}>
                                    <div className="col-sm-12 col-lg-12">
                                        <div className="dfsdf"><strong>Notes</strong></div>
                                        <textarea
                                            style={{ boxShadow: "0 1px 3px rgba(50, 50, 93, .15), 0 1px 0 rgba(0, 0, 0, .02)", border: "none", padding: "10px" }}
                                            value={this.state.notes || student.ctsd_notes || ""}
                                            onChange={this.handleNotesChange}
                                        />
                                        <div className="row justify-content-end mt-20">
                                            <button type="button" className="mr-10 mb-10 btn btn-outline-secondary float-right" onClick={this.addNotes}>Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </RctCollapsibleCard>
                        </div>
                    </div>
                )}
                {this.state.showModal && (
                    
                    <Dialog open={open} onClose={() => this.setState({ showModal: false })} PaperProps={{ style: { width: 576 } }}>
                        <DialogTitle>
                            <div disableTypography style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span>Add Program Inclusion</span>
                                <CloseIcon onClick={() => this.setState({ showModal: false })} style={{ cursor: 'pointer' }} />
                            </div>
                        </DialogTitle>
                        <DialogContent style={{ width: '100%' }}>
                            <div>
                                <table style={{ width: '100%' }}>
                                    <tbody>
                                        {programName.length > 0 &&
                                            programName.map((p, index) => (
                                                <tr key={p.ctpiID} style={{ display: 'flex', alignItems: 'center', borderTop: '1px solid #ccc' }}>
                                                    <td>{p.name}</td>
                                                    <td style={{ marginLeft: 'auto' }}>
                                                        
                                                        <input
                                                                class="form-check-input form-check-input-lg"
                                                                type="checkbox"
                                                                name="programinclusion[]"
                                                                value={p.id}
                                                                style={{ height: "2.5rem", width: "2.5rem", position: "relative" }}
                                                                onChange={(event) => {
                                                                    const updatedProgramName = [...programName];
                                                                    updatedProgramName[index].selected = event.target.checked;
                                                                    this.setState({ programName: updatedProgramName });
                                                                }}
                                                            />
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </DialogContent>
                        <DialogActions className="d-flex justify-content-center">
                        <button type="button" className="btn btn-outline-primary" onClick={() => this.handleAddPgi(student.ctsd_studentID)}>
                            <strong>Add</strong>
                        </button>
                        </DialogActions>
                    </Dialog>
                )}
                {/* Upload Document Dailog */}
                {this.state.showDocumentModal && (
                    <Dialog open={open} PaperProps={{ style: { width: 576 } }}>
                        <DialogTitle>
                            <div disableTypography style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span>Upload Document</span>
                                <CloseIcon onClick={() => this.setState({ showDocumentModal: false })} style={{ cursor: 'pointer' }} />
                            </div>
                        </DialogTitle>
                        <DialogContent style={{ width: '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="file-upload">File Name:</label>
                                <input id="file-upload" class="form-control" type="file" onChange={this.handleFileChange} />
                                {this.state.selectedFile && <span>{this.state.selectedFile.name}</span>}
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '16px' }}>
                                <label htmlFor="description">Description:</label>
                                <textarea id="description" rows={4} value={this.state.description} onChange={this.handleDescriptionChange} />
                            </div>
                        </DialogContent>
                        <DialogActions className="d-flex justify-content-center">
                            <button type="button" className="btn btn-outline-primary" onClick={() => this.handleUpload(student.ctsd_studentID)}>
                                <strong>Upload</strong>
                            </button>
                        </DialogActions>
                    </Dialog>
                )}
                {this.state.editAgreementModal && (
                    <Dialog open={open} PaperProps={{ style: { width: 576 } }}>
                        <DialogTitle>
                            <div disableTypography style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span>Edit Agreement</span>
                                <CloseIcon onClick={() => this.setState({ editAgreementModal: false })} style={{ cursor: 'pointer' }} />
                            </div>
                        </DialogTitle>
                        <DialogContent style={{ width: '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label class="col-form-label">Agreement Type</label>
                                    <Selectsearch
                                        options={agreementTypeOptions}
                                        value={agreementTypeOptions.find(obj => obj.value === String(this.state.agrtype)) || null}
                                        onChange={(selected) => this.setState({ agrtype: selected ? String(selected.value) : '' })}
                                        required
                                        />       
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label class="col-form-label">Agreement Start Date</label>
                                    <input type="date" name="agreementstdate" class="form-control" value={this.state.startdate} onChange={e => this.handleEdAgrmdate(e, 1)}/>                                        
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label class="col-form-label">Agreement End Date</label>
                                    <input type="date" name="agreementenddate" class="form-control" value={this.state.enddate} onChange={e => this.handleEdAgrmdate(e, 2)}/>                                        
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label class="col-form-label">Agreement Execution Date</label>
                                    <input type="date" name="agreementexcdate" class="form-control" value={this.state.excudate} onChange={e => this.handleEdAgrmdate(e, 3)}/>                                        
                            </div>
                        </DialogContent>
                        <DialogActions className="d-flex justify-content-center">
                            <button type="button" className="btn btn-outline-primary" onClick={() => this.handleEditAgreement()}>
                                <strong>Update</strong>
                            </button>
                        </DialogActions>
                    </Dialog>
                )}
                {this.state.ediv &&
                    <UpdateStudents1 onClick={this.onBackSection} data={this.state} />
                }
                {this.state.addagre &&
                    <AddAgreement onClick={this.onBackSection} data={this.state} />
                }

                {this.state.viewdoc &&
                    <ViewDocument onClick={this.onBackSection} data={this.state} />
                }

                {this.state.viewagr &&
                    <ViewAgreement onClick={this.onBackSection} data={this.state} />
                }

                <ConfirmationDialog
                    ref={this.confirmationDialog}
                    onConfirm={(res) => this.deleteDataPermanent(res)}
                    data={'program inclusion'}
                />

                <ConfirmationDialog
                    ref={this.confirmationDocument}
                    onConfirm={(res) => this.deleteDataDocument(res)}
                    data={'document'}
                />

                <ConfirmationDialog
                    ref={this.confirmationAgreement}
                    onConfirm={(res) => this.deleteDataAgreement(res)}
                    data={'agreement'}
                />
            </div>

        )
    }
}

const mapStateToProps = ({ contractstudent }) => {
    const { particularcontractstudent, travelformmail, loading, } = contractstudent;
    return { particularcontractstudent, travelformmail, loading };

}

export default connect(mapStateToProps, {
    contractProgramInclusion,
    contractFetchStudent,
    contractUpdateNotes,
    deleteStudentProgramInclusion,
    contractUploadDocument,
    contractAddPginc,
    deleteStudentAgreement,
    cancelStudentAgreement,
    deleteStudentDocument,
    fetchStudentDocument,
    fetchStudentAgreement,
    agreementAllDetails,
    editStudentAgreement,
})(UpdateStudent);

